<template>
  <div class="popup-container" @click="maskClose">
    <div ref="popup" class="popup5">
      <div class="mask"></div>
      <div @click.stop="iconClose" class="popup-close"></div>
      <div class="main">
        <div class="title">
          {{detail.title}}
          <span v-if="detail.author">（{{detail.author}}）</span>
        </div>
        <pre class="content">{{detail.text}}</pre>
      </div>
      <div v-if="type != 'review'" class="btn">
        <div class="previous" @click.stop="previous" :class="hasPrevious ? '': 'no-more'">上一首</div>
        <div class="next" @click.stop="next" :class="hasNext ? '': 'no-more'">下一首</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['detail', 'type', 'hasNext', 'hasPrevious'],
  mounted() {
    // document.body.style.backgroundImage = 'url("https://image.co-study.com.cn/web/answer-game/main-popup-bg.png")'
    document.body.style.background = '#5e523b'
  },
  beforeDestroy() {
    // document.body.style.backgroundImage = 'url("https://image.co-study.com.cn/web/answer-game/main-bg.png")'
    document.body.style.background = '#bda477'
  },
  methods: {
    maskClose(e) {
      if (!this.$refs.popup.contains(e.target)) {
        this.$emit('close')
      }
    },

    iconClose() {
      this.$emit('close')
    },

    previous() {
      this.$emit('previous')
    },

    next() {
      this.$emit('next')
    }
  }
}
</script>

<style lang="scss" scoped>
@function px2rem($px) {
  $rem: 375px;
  @return ($px/$rem) + rem;
}

.popup5 {
  width: px2rem(453px);
  height: px2rem(252px);
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  padding-top: px2rem(16px);

  .mask {
    width: px2rem(420px);
    height: px2rem(30px);
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.9),
      rgba(255, 255, 255, 0)
    );
    background: -webkit-linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.9),
      rgba(255, 255, 255, 0)
    );
    background: -o-linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.9),
      rgba(255, 255, 255, 0)
    );
    background: -moz-linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.9),
      rgba(255, 255, 255, 0)
    );
    position: absolute;
    top: px2rem(16px);
    left: px2rem(15px);
  }

  .main::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }

  .main {
    padding-top: px2rem(20px);
    max-width: px2rem(400px);
    height: px2rem(165px);
    overflow: scroll;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE 10+ */
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      font-size: px2rem(16px);
      color: #534831;
      margin-bottom: px2rem(20px);
      text-align: center;

      span {
        font-size: px2rem(10px);
        color: #a15b25;
      }
    }
    .content {
      font-size: px2rem(10px);
      color: #534831;
      line-height: px2rem(16px);
      white-space: pre-line;
    }
  }

  .btn {
    width: px2rem(416px);
    display: flex;
    justify-content: space-between;
    padding-top: px2rem(4px);

    .no-more {
      opacity: 0.5;
      filter: alpha(opacity=50); /* 针对 IE8 以及更早的版本 */
    }

    .previous,
    .next {
      width: px2rem(53px);
      height: px2rem(20px);
      line-height: px2rem(20px);
      background: url("https://image.co-study.com.cn/web/answer-game/yellow-bg.png");
      background-size: 100% 100%;
      font-size: px2rem(10px);
      color: #fff;
      text-align: center;
    }
  }
}
</style>
